var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Component, Schema, type, defaultValue } from "./decorators/type.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let DieOnTimeoutSchema = class extends Schema {
  constructor() {
    super(...arguments);
    __publicField(this, "timeElapsed");
    __publicField(this, "timeout");
  }
};
__decorateClass([
  type("number"),
  defaultValue(0)
], DieOnTimeoutSchema.prototype, "timeElapsed", 2);
__decorateClass([
  type("number"),
  defaultValue(1)
], DieOnTimeoutSchema.prototype, "timeout", 2);
DieOnTimeoutSchema = __decorateClass([
  Component("DieOnTimeout")
], DieOnTimeoutSchema);
const __vite_glob_0_33 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get DieOnTimeoutSchema() {
    return DieOnTimeoutSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  DieOnTimeoutSchema as D,
  __vite_glob_0_33 as _
};
//# sourceMappingURL=DieOnTimeout-1359a71f.js.map
